import { render, staticRenderFns } from "./applyFirst.vue?vue&type=template&id=2538020a&scoped=true&"
import script from "./applyFirst.vue?vue&type=script&lang=js&"
export * from "./applyFirst.vue?vue&type=script&lang=js&"
import style0 from "./applyFirst.vue?vue&type=style&index=0&id=2538020a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538020a",
  null
  
)

export default component.exports